import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit, OnDestroy {
    @Input() showClear = true;

    search = new FormControl('');
    start: string;

    unsubscribe$ = new Subject();

    public get value() {
        return this.search.value;
    }

    constructor(private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit() {
        this.search.valueChanges
            .pipe(
                debounceTime(400),
                distinctUntilChanged(),
                takeUntil(this.unsubscribe$)
            )
            .subscribe(value => this.searchChanged(value));

        this.route.queryParamMap
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(params => {
                this.search.setValue(params.get('search'));
                this.start = params.get('start');
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    clear() {
        this.search.setValue('');
    }

    async searchChanged(value: string) {
        if (value === '') {
            value = null;
        }
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                search: value,
                start: this.start && this.start !== '0' ? 0 : null
            },
            queryParamsHandling: 'merge'
        });
    }

}
